<template>
    <div class="sc-inner">
        <div class="container">
            <div class="sc-headline a-center">
                <h2 class="sc-heading">Instagram</h2>
                <div class="sc-desc">Follow us at <a href="https://www.instagram.com/bkkmenu/" target="_blank"><em>@BKKMENU</em></a></div>
            </div>
            <div class="sc-content">

                <div class="igfeed-group">
                    <div class="ig-col ig-col-1">
                        <!--1-->
                        <div class="ig-item">
                            <a class="item" :href="list[0].linkto" target="_blank" rel="nofollow">
                                <div class="image" v-lazy:background-image="list[0].img">
                                    <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/640x640.gif'" alt="BKKMENU" class="bound">
                                </div>
                                <span class="username">#BKKMENU</span>
                                <TagDotDotDot v-if="list[0].caption" :text="list[0].caption" :tag="'span'" :customClass="'caption'" />
                            </a>
                        </div>
                    </div>

                    <div class="ig-col ig-col-2">

                        <!--2-->
                        <div class="ig-item">
                            <a class="item" :href="list[1].linkto" target="_blank" rel="nofollow">
                                <div class="image" v-lazy:background-image="list[1].img">
                                    <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/640x640.gif'" alt="BKKMENU" class="bound">
                                </div>
                                <span class="username">#BKKMENU</span>
                                <TagDotDotDot v-if="list[1].caption" :text="list[1].caption" :tag="'span'" :customClass="'caption'" />
                            </a>
                        </div>

                        <!--3-->
                        <div class="ig-item">
                            <a class="item" :href="list[2].linkto" target="_blank" rel="nofollow">
                                <div class="image" v-lazy:background-image="list[2].img">
                                    <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/640x640.gif'" alt="BKKMENU" class="bound">
                                </div>
                                <span class="username">#BKKMENU</span>
                                <TagDotDotDot v-if="list[2].caption" :text="list[2].caption" :tag="'span'" :customClass="'caption'" />
                            </a>
                        </div>

                        <!--4-->
                        <div class="ig-item">
                            <a class="item" :href="list[3].linkto" target="_blank" rel="nofollow">
                                <div class="image" v-lazy:background-image="list[3].img">
                                    <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/640x640.gif'" alt="BKKMENU" class="bound">
                                </div>
                                <span class="username">#BKKMENU</span>
                                <TagDotDotDot v-if="list[3].caption" :text="list[3].caption" :tag="'span'" :customClass="'caption'" />
                            </a>
                        </div>

                        <!--5 on mobile-->
                        <div class="ig-item ig-item-device">
                            <a class="item" :href="list[4].linkto" target="_blank" rel="nofollow">
                                <div class="image" v-lazy:background-image="list[4].img">
                                    <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/640x640.gif'" alt="BKKMENU" class="bound">
                                </div>
                                <span class="username">#BKKMENU</span>
                                <TagDotDotDot v-if="list[4].caption" :text="list[4].caption" :tag="'span'" :customClass="'caption'" />
                            </a>
                        </div>

                    </div>

                    <div class="ig-col ig-col-3">

                        <!--5-->
                        <div class="ig-item">
                            <a class="item" :href="list[4].linkto" target="_blank" rel="nofollow">
                                <div class="image" v-lazy:background-image="list[4].img">
                                    <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/640x640.gif'" alt="BKKMENU" class="bound">
                                </div>
                                <span class="username">#BKKMENU</span>
                                <TagDotDotDot v-if="list[4].caption" :text="list[4].caption" :tag="'span'" :customClass="'caption'" />
                            </a>
                        </div>

                        <!--6-->
                        <div class="ig-item">
                            <a class="item" :href="list[5].linkto" target="_blank" rel="nofollow">
                                <div class="image" v-lazy:background-image="list[5].img">
                                    <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/640x640.gif'" alt="BKKMENU" class="bound">
                                </div>
                                <span class="username">#BKKMENU</span>
                                <TagDotDotDot v-if="list[5].caption" :text="list[5].caption" :tag="'span'" :customClass="'caption'" />
                            </a>
                        </div>

                        <!--7-->
                        <div class="ig-item">
                            <a class="item" :href="list[6].linkto" target="_blank" rel="nofollow">
                                <div class="image" v-lazy:background-image="list[6].img">
                                    <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/640x640.gif'" alt="BKKMENU" class="bound">
                                </div>
                                <span class="username">#BKKMENU</span>
                                <TagDotDotDot v-if="list[6].caption" :text="list[6].caption" :tag="'span'" :customClass="'caption'" />
                            </a>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import jQuery from 'jquery'
import config from '@/../myconfig.js'

import TagDotDotDot from '@/components/parts/TagWithDotDotDot.vue'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

window.jQuery = window.$ = jQuery
const myConfig = config

const initIgData = []
for (var i = 0; i < 7; i++) {
  initIgData.push({
    caption: null,
    linkto: null,
    img: null
  })
}

export default {
  name: 'InstagramHome',
  components: {
    TagDotDotDot
  },
  mounted () {
    fetch(myConfig.API_PATH + 'api/instagram').then(res => {
      return res.json()
    }).then(data => {
      this.list = data
    })

    this.$nextTick(() => {

      // require('@/assets/theme/bkkmenu-2017/assets/js/dotdotdot/jquery.dotdotdot.min.js')

    //   setTimeout(function () {
    //     $('.caption').dotdotdot({
    //       ellipsis: '...',
    //       wrap: 'letter',
    //       fallbackToLetter: true,
    //       watch: true,
    //       after: '.ic'
    //     })
    //   }, 200)
    })
  },
  data: function () {
    return {
      list: initIgData,
      THEME_PATH: myConfig.THEME_PATH
    }
  }
}
</script>
